import { supabase } from '../../../lib/supabaseClient';

export async function signASP(aspId, signerType, signatureData, attestationConfirmed = false) {
  const { data, error } = await supabase
    .rpc('sign_asp', {
      p_asp_id: aspId,
      p_signer_type: signerType,
      p_signature_data: signatureData,
      p_attestation_confirmed: attestationConfirmed
    });

  if (error) throw error;
  return data;
}

export async function getASPSignatures(aspId) {
  const { data, error } = await supabase
    .from('asp_signatures')
    .select('*')
    .eq('asp_id', aspId)
    .order('signed_at', { ascending: true });

  if (error) throw error;
  return data || [];
}
